import { trans } from "@mongez/localization";
import { URLS } from "framework/config/urls";
import notFoundImg from "~/assets/images/404.png";
import backgroundPattern from "~/assets/images/pattern.png";
import { BaseLink } from "~/design-system/components";

export function NotFoundPage() {
  return (
    <div className="from-primary-200 relative bg-linear-to-b to-transparent py-10 sm:py-20">
      <img
        src={backgroundPattern}
        alt="pattern"
        className="absolute top-0 left-0 h-full w-full object-cover object-center opacity-20"
      />

      <div className="relative container flex flex-col items-center gap-6">
        <img src={notFoundImg} alt={trans("notFound")} className="mb-5" />

        <div className="flex w-full flex-col items-center gap-6 text-center sm:max-w-[650px]">
          <h1 className="font-playfair text-2xl font-bold capitalize sm:text-3xl xl:text-4xl">
            OOPS..!!
          </h1>
          <p className="font-avenir text-lg font-medium capitalize sm:text-xl xl:text-2xl">
            {trans("notFoundDescription")}
          </p>
        </div>

        <div className="flex w-full max-w-[450px] items-center justify-center gap-4">
          <BaseLink
            to={URLS.home}
            className="rounded-full border bg-[#E8CFD3] px-6 py-3"
          >
            {trans("backToHome")}
          </BaseLink>
          <BaseLink
            to={URLS.contactUs}
            className="rounded-full border px-6 py-3"
          >
            {trans("contactUs")}
          </BaseLink>
        </div>
      </div>
    </div>
  );
}
